import React, { useLayoutEffect, useRef } from 'react';

interface AnimatedReorderItemProps {
  children: React.ReactNode;
  orderKey?: string | number;
}

const AnimatedReorderItem: React.FC<AnimatedReorderItemProps> = ({ children, orderKey }) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const prevRectRef = useRef<DOMRect | null>(null);

  useLayoutEffect(() => {
    const node = ref.current;
    if (!node) return;

    const nextRect = node.getBoundingClientRect();
    const prevRect = prevRectRef.current;

    if (prevRect) {
      const deltaX = prevRect.left - nextRect.left;
      const deltaY = prevRect.top - nextRect.top;

      if (deltaX !== 0 || deltaY !== 0) {
        node.style.transition = 'none';
        node.style.transform = `translate(${deltaX}px, ${deltaY}px)`;

        requestAnimationFrame(() => {
          node.style.transition = 'transform 250ms ease';
          node.style.transform = '';
        });
      }
    }

    prevRectRef.current = node.getBoundingClientRect();

    return () => {
      if (ref.current) {
        prevRectRef.current = ref.current.getBoundingClientRect();
      }
    };
  }, [orderKey]);

  return (
    <div ref={ref} style={{ willChange: 'transform' }}>
      {children}
    </div>
  );
};

export default AnimatedReorderItem;
